// extracted by mini-css-extract-plugin
export var chevronIcon = "_s8-1";
export var edgeToggle = "_s8-0";